<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <DatePickerRange title="回访时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>

        <div class="dialog-input-item">
          <label>回访门店</label>
          <el-select v-model="shopId" placeholder="Select" class="select-item">
            <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>回访类型</label>
          <el-select v-model="projectServiceType" placeholder="Select" class="select-item">
            <el-option v-for="item in projectServiceTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>满意度</label>
          <el-select v-model="satisfaction" placeholder="Select" class="select-item">
            <el-option v-for="item in satisfactionArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
<!--        <div class="dialog-input-item">-->
<!--          <label>回访状态</label>-->
<!--          <el-select v-model="state" placeholder="Select" class="select-item">-->
<!--            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
        <div class="dialog-input-item">
          <label>复核状态</label>
          <el-select v-model="recheckState" placeholder="Select" class="select-item">
            <el-option v-for="item in recheckStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>问题反馈</label>
          <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
      </div>
      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>
<!--        <div class="dialog-input-btn">-->
<!--          <ElButtons type="success" icon="plus" @click="add"> 添加 </ElButtons>-->
<!--        </div>-->
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="visitTime" label="回访时间"/>
      <el-table-column property="shopName" label="回访门店"/>
      <el-table-column property="" label="回访类型">
        <template #default="scope">
          {{scope.row.projectServiceType == 1?'洗澡项目':scope.row.projectServiceType == 2?'增值项目':scope.row.projectServiceType == 3?'物品销售':scope.row.projectServiceType == 4?'活体销售':scope.row.projectServiceType == 5?'其他':''}}
        </template>
      </el-table-column>
      <el-table-column property="" label="回访备注">
        <template #default="scope">
          <p>回访项目：{{scope.row.name}}</p>
          <p>回访天数：{{scope.row.dayNum}}</p>
        </template>
      </el-table-column>
      <el-table-column property="" label="回访满意度">
        <template #default="scope">
          {{ scope.row.satisfaction == 1?'不满意':scope.row.satisfaction == 2?'一般':scope.row.satisfaction == 3?'满意':scope.row.satisfaction == 4?'未回复':'' }}
        </template>
      </el-table-column>
      <el-table-column property="problem" label="问题反馈" width="200"/>
      <el-table-column property="" label="回访截图">
        <template #default="scope">
          <div v-if="scope.row.visitImgList && scope.row.visitImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
            <el-image class="item-img" fit="fill" :src="scope.row.visitImgList[0].img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
          <div v-else>
            <el-image class="item-img" fit="fill"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column property="" label="复核状态">
        <template #default="scope">
          {{scope.row.recheckState == 1?'待复核':scope.row.recheckState == 2?'已超时':scope.row.recheckState == 3?'审核中':scope.row.recheckState == 4?'资料驳回':scope.row.recheckState == 5?'不通过':scope.row.recheckState == 6?'已通过':''}}
        </template>
      </el-table-column>
      <el-table-column property="visitAdminName" label="回访人"/>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import { getUserVisitPageList, getRecordShops} from '@/api/url';
import Dialog from '../../assets/js/dialog'
import AddUserRemarkDialog from './AddUserRemarkDialog';
import DatePickerRange from "@/components/DatePickerRange";
import SearchComponents from "@/components/SearchComponents";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      pageDataList: [],
      id: this.value.id,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      shopId: 0,
      shopIdArray: [],

      projectServiceTypeArray: [
        {label: '不限', value: -1},
        {label: '洗澡项目', value: 1},
        {label: '增值项目', value: 2},
        {label: '物品销售', value: 3},
        {label: '活体销售', value: 4},
        {label: '其他', value: 5},
      ],
      projectServiceType: -1,

      satisfaction: -1,
      satisfactionArray: [
        {label: '不限', value: -1},
        {label: '不满意', value: 1},
        {label: '一般', value: 2},
        {label: '满意', value: 3},
        {label: '未回复', value: 4}
      ],

      recheckState: -1,
      recheckStateArray: [
        {label: '不限', value: -1},
        {label: '待复核', value: 1},
        {label: '已超时', value: 2},
        {label: '审核中', value: 3},
        {label: '资料驳回', value: 4},
        {label: '不通过', value: 5},
        {label: '已通过', value: 6},
      ],

      state: -1,
      stateArray: [
        {label: '不限', value: -1},
        {label: '未回访', value: 0},
        {label: '已超时', value: 1},
        {label: '已回访', value: 2},
      ],


      //搜索
      searchTypeList: [
        {label : '问题反馈', value : 1}
      ],
      searchType: 1,
      searchValue: '',
    }
  },
  methods: {

    userImgList(row) {
      let _title = '';
      _title = '回访图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.visitImgList,
          id: row.id,
          width: 908,
          from: 4,
          hideBtn: true
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.id;
      param['shopId'] = this.shopId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      // param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['projectServiceType'] = this.projectServiceType;
      param['state'] = this.state;
      param['recheckState'] = this.recheckState;
      param['satisfaction'] = this.satisfaction;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getUserVisitPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.sort(this.compare)
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          // if(this.pageDataList.length > 3) {
          //   sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList.slice(0,3)));
          // } else {
          //   sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList));
          // }
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },
    // add() {
    //   Dialog.open({
    //     title: '添加备注',
    //     component: AddUserRemarkDialog,
    //     data: {
    //       id: this.id
    //     },
    //     confirm: (result) => {
    //       this.getPage();
    //     }
    //   })
    // }

    getRecordShop() {
      let param = {}
      param['userId'] = this.id
      param['type'] = 3
      getFormData(getRecordShops, param).then(data => {
        this.shopIdArray = []
        this.shopIdArray = this.shopIdArray.concat(data.data)
      })
    }

  },
  mounted() {
    // sessionStorage.removeItem('userLog');
    this.getRecordShop()
    this.getPage();
  }
}
</script>

<style>
.item-img {
  width: 80px;
  height: 80px;
}
</style>
